export const GET_SCHEME_TYPE_LIST = "GET_SCHEME_TYPE_LIST"
export const GET_SCHEME_TYPE_LIST_SUCCESS = "GET_SCHEME_TYPE_LIST_SUCCESS"

export const SAVE_SCHEME_TYPE_MASTER = "SAVE_SCHEME_TYPE_MASTER"
export const SAVE_SCHEME_TYPE_SUCCESS = "SAVE_SCHEME_TYPE_SUCCESS"

export const EDIT_SCHEME_TYPE_ID = "EDIT_SCHEME_TYPE_ID"
export const EDIT_SCHEME_TYPE_ID_SUCCESS = "EDIT_SCHEME_TYPE_ID_SUCCESS"

export const UPDATE_SCHEME_TYPE_ID = "UPDATE_SCHEME_TYPE_ID"
export const UPDATE_SCHEME_TYPE_ID_SUCCESS = "UPDATE_SCHEME_TYPE_ID_SUCCESS"

export const DELETE_SCHEME_TYPE_ID = "DELETE_SCHEME_TYPE_ID"
export const DELETE_SCHEME_TYPE_ID_SUCCESS = "DELETE_SCHEME_TYPE_ID_SUCCESS"

export const VALIDE_SCHEME_TYPE_ID = "VALIDE_SCHEME_TYPE_ID"
export const VALIDE_SCHEME_TYPE_ID_SUCCESS = "VALIDE_SCHEME_TYPE_ID_SUCCESS"

export const SCHEME_TYPE_ERROR_ACTION = "SCHEME_TYPE_ERROR_ACTION"




